import React, { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import reqFornecedor from "../../services/reqMultiTenant/reqFornecedor";
import reqCliente from "../../services/reqMultiTenant/reqCliente";

const SearchSelectDynamic = ({
	id,
	labelSelect,
	label,
	control,
	errors,
	handleSelect = () => {}, // usado como callback para quando selecionar um item da lista para lista em cascata
	onKeyDown = () => {},
	loading: externalLoading, // Mantém a possibilidade de passar loading externo
	className = "",
	autoFocus = false,
	req = reqFornecedor,
}) => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]); // Contém os dados da busca
	const [formattedOptions, setFormattedOptions] = useState([]); // Contém as opções formatadas da busca (value e label)

	const selectRef = useRef(null); // Criação da referência para setar o focus e abrir o menu
	const [focus, setFocus] = useState(false); // Gerencia o estado de foco, para abrir somente após a primeira busca

	//#region quando muda os dados ele formata os dados para o select
	useEffect(() => {
		if (data?.length > 0) {
			const newformattedOptions = data.map((option) => ({
				value: option[id], //o que quer q retorna ex.: id_cidade
				label: option[labelSelect], //o que quer q apareça ex.: nome
			}));

			setFormattedOptions(newformattedOptions);

			focus && focusAndOpenMenu();
			setFocus(true);
		}
	}, [data]);
	//#endregion

	//#region Funções para buscar dados
	useEffect(() => {
		fetch("");
	}, []);

	const fetch = async (nomefantasia) => {
		try {
			setLoading(true);
			let response;
			if (req === "reqCliente") {
				response = await reqCliente.listPaginate("nome", nomefantasia, "SIM", 1);
			} else response = await reqFornecedor.listPaginate("nomefantasia", nomefantasia, "SIM", 1);
			setData(response.data);
		} catch (error) {
			console.log("Erro ao buscar os dados:", error);
		} finally {
			setLoading(false);
		}
	};

	const fetchID = async (filterId = null) => {
		try {
			setLoading(true);
			let response;
			if (filterId) {
				// Busca apenas o fornecedor específico
				response = await reqFornecedor.findById(filterId);
			} else {
				// Nenhum fornecedor selecionado, inicializa com dados vazios
				response = { data: [] };
			}
			setData(response.data);
		} catch (error) {
			console.error("Erro ao buscar os dados:", error);
			setData([]);
		} finally {
			setLoading(false);
		}
	};
	//#endregion

	//#region quando digitar no input ele vai buscar os dados no servidor
	const [searchInput, setSearchInput] = useState(""); // Estado para armazenar o input de pesquisa

	useEffect(() => {
		if (!searchInput.trim()) return;
		const delayDebounceFn = setTimeout(() => {
			fetch(searchInput);
		}, 1300);
		return () => clearTimeout(delayDebounceFn);
	}, [searchInput]);

	//evento onChange do input
	const handleInputChange = (inputValue, { action }) => {
		if (action === "input-change") {
			const upperCaseValue = inputValue.toUpperCase();
			setSearchInput(upperCaseValue); //
		}
	};
	//#endregion

	//#region quando seleciona um item ele atualiza o valor no formulario e executa a função handleSelect
	const handleOnChange = (selectedOption, onChange, value) => {
		const oldValue = value;
		const newValue = selectedOption?.value;

		if (oldValue === newValue) return;

		onChange(newValue);
		handleSelect(selectedOption);
	};

	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			const focusedOption = document.querySelector(".react-select__option--is-focused");

			// quando o enter não vem de uma seleção de opção ele vai para o próximo campo
			if (!focusedOption) {
				event.preventDefault();
				onKeyDown(event);
			}
		}
	};

	// Procura o valor na lista de opções
	const handleValue = (formattedOptions, value) => {
		const selectedOption = formattedOptions.find((option) => option.value === value) || null;
		return selectedOption;
	};
	//#endregion

	//#region estilos do select e focus
	const customStyles = {
		control: (provided, state) => ({
			...provided,
			borderColor: state.isFocused ? "#333" : "#aaa",
			boxShadow: state.isFocused ? "0 0 0 1px #e6e6e6" : "none",
			"&:hover": {
				borderColor: "#cfcece",
			},
		}),
	};

	const focusAndOpenMenu = () => {
		if (selectRef.current) {
			// Focar no componente
			selectRef.current.focus();
			// Abrir o menu
			selectRef.current.openMenu();
		}
	};
	//#endregion

	return (
		<div className={`input-select-box d-flex flex-column mb-2 ${className}`}>
			<label htmlFor={id}>{label}</label>
			<Controller
				name={id}
				control={control}
				render={({ field: { onChange, value } }) => (
					<Select
						// autoFocus={autoFocus}
						id={id}
						ref={selectRef} // Passa a referência
						options={formattedOptions}
						value={handleValue(formattedOptions, value)} // Relaciona o valor inicial
						onChange={(selectedOption) => handleOnChange(selectedOption, onChange, value)}
						onInputChange={handleInputChange}
						onKeyDown={handleKeyDown}
						classNamePrefix="react-select"
						styles={customStyles}
						isDisabled={loading}
						isLoading={loading || externalLoading}

						// menuIsOpen={menuShouldOpen || undefined} // Abre o menu se `menuShouldOpen` for verdadeiro
						// onMenuOpen={() => setMenuShouldOpen(false)} //
					/>
				)}
			/>

			{errors?.[id] && <p className="errors">{errors[id].message}</p>}
		</div>
	);
};

export default SearchSelectDynamic;
